// extracted by mini-css-extract-plugin
export default {"cell":"styles__cell___yF81N","accessoryTag":"styles__accessoryTag___X0wkY"};